import React from 'react';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import Cookies from 'js-cookie';

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const cookieOptions = isLocalhost
    ? { sameSite: 'Lax', expires: 5 }
    : { secure: true, sameSite: 'Strict', expires: 5, domain: '.miporis.com' };

const GoogleAuth = ({ showToast }) => {
    const toast = (msg, type) => showToast ? showToast(msg, type) : console[type === 'error' ? 'error' : 'log'](msg);
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '942010598574-i36ar4ct4hdv7pmlrr4igcp6dr22jkvq.apps.googleusercontent.com';
    const appUrl = process.env.REACT_APP_API_BASE_URL || 'https://app.miporis.com';
    const backendUrl = process.env.REACT_APP_MIPORIS_SERVER || 'https://app.miporis.com/api';

    const handleSuccess = async (credentialResponse) => {
        if (!credentialResponse?.credential) {
            toast('Authentication failed. Please try again.', 'error');
            return;
        }

        try {
            const response = await fetch(`${backendUrl}/auth/google-auth`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ credential: credentialResponse.credential }),
            });

            if (!response.ok) throw new Error('Authentication request failed');
            const data = await response.json();

            if (data.token) {
                Cookies.set('token', data.token, cookieOptions);
                toast('Login successful!', 'success');
                if (data.isPaid) {
                    window.location.replace(appUrl);
                } else {
                    window.location.href = '/pricing';
                }
            } else {
                toast('Token not received. Login unsuccessful.', 'error');
            }
        } catch (err) {
            console.error('Error during Google authentication:', err);
            toast('An error occurred. Please try again later.', 'error');
        }
    };

    const handleError = () => {
        toast('Google login failed. Please try again.', 'error');
        console.log('Google Login Failed');
    };

    return (
        <div className="w-full flex justify-center">
            <GoogleOAuthProvider clientId={clientId}>
                <GoogleLogin
                    onSuccess={handleSuccess}
                    onError={handleError}
                    className="w-full"
                />
            </GoogleOAuthProvider>
        </div>
    );
};

export default GoogleAuth;
